import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  SimpleChanges,
  OnChanges,
  OnDestroy,
  ViewChild
} from "@angular/core";
import * as moment from "moment";
import { MessageService } from './../../../services/message-service';
import { GenericUtils } from "./../../../utilities/generic-utils"
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Params, ActivatedRoute } from "@angular/router";
import { DaterangepickerDirective } from "ngx-daterangepicker-material";
@Component({
  selector: "app-date-range-filter",
  templateUrl: "./date-range-filter.component.html",
  styleUrls: ["./date-range-filter.component.scss"]
})


export class DateRangeFilterComponent implements OnInit, OnChanges, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  modelName = '';
  @Input() model: string = "";
  @Input() label: string = "";
  @Input() divClass: string = "";
  @Input() quickFilters: Boolean = false;
  @Input() defaultValue = "";
  @Output() dateRangeValueEmit = new EventEmitter();
  @Input() valueFromParams = "";

  @Input() maxDate = 1;
  @Input() minDate; // reserved for future purposes -- no use now
  @Input() noDateLimit = true;
  @Input() index = '';
  @Input() position = '';
  setMax = moment().subtract(this.maxDate, "days");
  setMin;
  getday = moment()
    .subtract(1, "days")
    .date();
  selected: any = {
    startDate: moment().subtract(this.getday, "days"),
    endDate: moment().subtract(1, "days")
  };
  defaultValueField = {
    startDate: moment().subtract(this.getday, "days"),
    endDate: moment().subtract(this.maxDate, "days")
  }
  defaultPrevMonthField = {
    startDate: moment().subtract(this.getday, "days").subtract(1, "month"),
    endDate: moment().subtract(this.getday + 1, "days")
  }

  ranges: any = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'Last 90 Days': [moment().subtract(89, 'days'), moment()]
  }
  
  alwaysShowCalendars: true;

  @Output() ddClickedEvent = new EventEmitter();
  @ViewChild(DaterangepickerDirective) pickerDirective: DaterangepickerDirective;

  constructor(private message: MessageService, private utils: GenericUtils, private activateRoute: ActivatedRoute) {
  }

  ngOnInit() {
    const getday = moment()
      .subtract(1, "days")
      .date();
    const selected = {
      startDate: moment().subtract(getday, "days"),
      endDate: moment().subtract(this.maxDate, "days")
    };

    this.setMax = moment().subtract(this.maxDate, "days");
    const today = new Date();
    if (today.getDate() < 6) {
      this.selected.startDate.subtract(1, "months");
      selected.startDate.subtract(1, "months");
    }

   // this.selected.endDate = moment().subtract(this.maxDate, "days"); //will be done later
    this.defaultValueField = {
      startDate: selected.startDate,
      endDate: selected.endDate
    };



    if (this.model) {
      this.modelName = JSON.parse(this.model)[1].indexOf('start') ? JSON.parse(this.model)[0].replace('__start', '') : JSON.parse(this.model)[0].replace('__end', '');
    }
    if (!this.valueFromParams) { // Reworking date-range- work in progress
      if (this.defaultValue && this.defaultValue[`${this.modelName}__start`] && this.defaultValue[`${this.modelName}__end`]) {  
        this.setDefaultValue();
      }else{
        this.selected = this.defaultValueField;
      }
    } else { // Reworking date-range- work in progress
      this.setValueFromParams();
    }

    this.message.getMessage().pipe(takeUntil(this.unsubscribe)).subscribe(message => {

      if (message && message.filterReset) {
        const defaultValueField = {
          startDate: moment().subtract(6, 'days'),
          endDate: moment()
        }
        this.selected = defaultValueField;
      }
    });

    this.activateRoute.queryParams.pipe(takeUntil(this.unsubscribe)).subscribe((params: Params) => {

      if (Object.keys(params).length) {
        if (this.modelName == 'order_create_date' && !params['order_create_date__start']) {
          this.defaultValue = ''
          this.selected = ''
        }
        if (this.modelName == 'order_update_date' && !params['order_update_date__start']) {
          this.defaultValue = ''
          this.selected = ''
        }
      }
    })
  }

  changeDate(month) {

    if (month === 'prev') {
      this.selected = this.defaultPrevMonthField;
    }
    if (month === 'curr') {
      this.selected = this.defaultValueField;
    }

  }

  ngOnChanges(changes: SimpleChanges) {

    if (!this.valueFromParams) { // temporary measure till we fix other modules
      if (this.defaultValue && this.defaultValue[`${this.modelName}__start`] && this.defaultValue[`${this.modelName}__end`]) {
        this.setDefaultValue();
      }
    }
    if (changes.valueFromParams) {
      if (this.valueFromParams && Object.keys(this.valueFromParams).length) {
        this.setValueFromParams();
      }
    }

  }

  setValueFromParams() {
    Object.keys(this.valueFromParams).map(field => {
      if (!this.valueFromParams[field]) {
        this.selected = null;
      } else if (field.indexOf("start") > -1) {
        this.selected.startDate = moment(this.valueFromParams[field]);

      } else if (field.indexOf("end") > -1) {
        this.selected.endDate = moment(this.valueFromParams[field]);
      }
    });
  }

  setDefaultValue() {
    Object.keys(this.defaultValue).map(field => {
      if (field.indexOf("start") > -1) {
        this.selected.startDate = moment(this.defaultValue[field]);
      } else if (field.indexOf("end") > -1) {
        this.selected.endDate = moment(this.defaultValue[field]);
      }
    });
  }

  dateRangeSelected($event) {

    if ($event.startDate && $event.endDate) {
      const startDate = moment($event.startDate).format("YYYY-MM-DD");
      const endDate = moment($event.endDate).format("YYYY-MM-DD");
      this.dateRangeValueEmit.emit({
        model: this.model,
        value: { startDate, endDate }
      });
    } else {
      this.dateRangeValueEmit.emit({
        model: this.model,
        value: { startDate: "", endDate: "" }
      });
    }
  }
  public click(value: any) {
    this.ddClickedEvent.emit(true);
    const tempEle = document.querySelectorAll(".md-drppicker.drops-down-auto");

    for (let i = 0; i < tempEle.length; i++) {
      tempEle[i]["style"].visibility = "hidden";

    }
    setTimeout(function () {
      const ele = document.querySelector(".md-drppicker.drops-down-auto.ltr.shown.double");
      if (ele){
      if (window.innerWidth - value.clientX < 500) {
        ele["style"]["left"] = "auto";
        ele["style"]["right"] = "8px";
      }else {
        ele["style"]["right"] = "auto";
        ele["style"]["left"] = "8px";
      }
      ele["style"]["visibility"] = "visible"; 
    }

    }, 0);

  }

  openDatepicker() {
    this.ddClickedEvent.emit(true);
    this.pickerDirective.open();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
